import Grid from "@mui/material/Grid";
import React, { useRef, useEffect, useState } from "react";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Header from "layouts/authentication/components/Header";
import { useMsal } from "@azure/msal-react";

// Define training links per user role
const trainingLinks = {
  ShenAdmin: ["/iSpring/Regular/index.html"],
  ShenAdmin: ["/iSpring/Regular/index.html"],

  ShenREG: ["/iSpring/Regular/index.html"],

  // Mapping ADV roles to the same training links
  ShenADV: ["/iSpring/Regular/index.html"],
};
function Training() {
  const iframeRef = useRef(null);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const userRoles = activeAccount?.idTokenClaims?.roles || [];

  // Use selected role from local storage or first available role
  const [selectedRole, setSelectedRole] = useState(
    localStorage.getItem("selectedRole") || userRoles[0] || ""
  );

  useEffect(() => {
    const storedRole = localStorage.getItem("selectedRole");
    if (storedRole && selectedRole !== storedRole) {
      setSelectedRole(storedRole);
    }
  }, []);

  // Get the training links based on the selected role
  const availableLinks = trainingLinks[selectedRole] || [];

  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      iframeRef.current.requestFullscreen().catch((err) => {
        alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
      });
    } else {
      document.exitFullscreen();
    }
  };

  return (
    <DashboardLayout>
      <Header title="Training Presentations" />
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item xs={true}>
          <DashboardNavbar />
        </Grid>
        <Grid item sx={{ marginTop: "2rem" }}>
          <MDButton color="info" onClick={toggleFullScreen}>
            Toggle Full Screen
          </MDButton>
        </Grid>
      </Grid>

      {availableLinks.length > 0 ? (
        availableLinks.map((link, index) => (
          <MDBox
            key={index}
            variant="contained"
            bgColor="white"
            borderRadius="sm"
            coloredShadow="dark"
            mb={3}
          >
            <div style={{ position: "relative", paddingTop: "56.25%" }}>
              <iframe
                ref={iframeRef}
                title={`Training Presentation ${index + 1}`}
                src={link}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  border: "none",
                }}
              />
            </div>
          </MDBox>
        ))
      ) : (
        <p style={{ textAlign: "center", fontSize: "20px", fontWeight: "bold" }}>
          No Training Available for Your Selected Role
        </p>
      )}
    </DashboardLayout>
  );
}

export default Training;
